// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { type Currencies } from '../../../utilities/types';
import { loadCommissionDueIndex } from './reducer';
import CrudTableIndex from '../../../modules/CrudTable/CrudTableIndex';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

export type CommissionDue = {
  currency: string,
  transaction_amount: string,
  transaction_fee: string,
  revenue_share: string
};

type Props = {
  commissionDueIndex: Array<CommissionDue>,
  currencies: Currencies,
  loadCommissionDueIndex: () => void,
  failedLoad: boolean,
  loading: boolean
};

class CommissionDueIndex extends Component<Props> {
  render() {
    return (
      <CrudTableIndex
        // Table
        TableHeader={<TableHeader />}
        tableData={this.props.commissionDueIndex}
        loadTableIndexData={this.props.loadCommissionDueIndex}
        loading={this.props.loading}
        failedLoad={this.props.failedLoad}
        currencies={this.props.currencies}
        // $FlowFixMe props are passed in by cloneElement
        TableRow={<TableRow />}
        tableBodyOptions={{
          text: 'No Commissions Due',
          model: 'Pending Commissions',
          img: 'moneyHand'
        }}
      />
    );
  }
}

const mapStateToProps = state => ({
  currencies: state.global.currencies,
  commissionDueIndex:
    state.commissionPayouts.commissionDue.index.pending_commission_payouts,
  loading: state.commissionPayouts.commissionDue.index.loading,
  failedLoad: state.commissionPayouts.commissionDue.index.failedLoad
});

const mapDispatchToProps = {
  loadCommissionDueIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(CommissionDueIndex);
